'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');
var FormAbstractElement = require('./form__abstractelement.js');

/**
 * Creates a Tab
 *
 * @class
 */

class Form extends Core {

    _defaults() {
        return {
            target: '.js-form',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__form'>
                <div class='grid'>
                    <div class='grid__item three-quarters'>
                        <div class='js-editor__form__left'></div>
                    </div>
                    <div class='grid__item one-quarter'>
                        <div class='js-editor__form__right'></div>
                    </div>
                </div>
            </div>
        `;

        super.render();
    }

    /**
     * add a single text input
     *
     * @param {String} label
     */
    addFormElement(label){
        return new FormAbstractElement({
            target: $('.js-editor__form__left', this.$el),
            fields: {
                'label': label
            }
        });
    }

   

}
module.exports = Form;